import { createElement } from 'react';
import './index.scss';
const styleFunction = (type, bgColors, textColors, checked) => {
    const bgColor = checked ? bgColors[1] : bgColors[0];
    const textColor = checked ? textColors[1] : textColors[0];
    if (type === 'button') {
        return { 'backgroundColor': bgColor, 'color': textColor };
    }
    if (type === 'text') {
        return {
            'color': textColor,
            'position': checked ? 'relative' : 'static',
        };
    }
    return {};
};
const RadioGroupItem = ({ label = '标签', value = 'value', checked, type = 'button', name, selectColor = '#F5743F', selectTextColor = 'white', unSelectColor = '#F0F0F0', unSelectTextColor = '#727272', onChange, ...otherProps }) => {
    const _otherProps = otherProps || {};
    const handleChange = (event) => {
        onChange(event.target.value);
    };
    const customStyle = styleFunction(type, [unSelectColor, selectColor], [unSelectTextColor, selectTextColor], checked);
    if (_otherProps.style) {
        _otherProps.style = {
            ..._otherProps.style,
            ...customStyle
        };
    }
    else {
        _otherProps.style = {
            ...customStyle
        };
    }
    const className = type === 'button' ? 'radio-group-item__button' : 'radio-group-item__text';
    return (createElement("label", { key: value, className: className, ..._otherProps },
        type === 'text' && checked && (createElement("span", { className: "radio-group-item__text__line", style: { 'background-color': selectColor } })),
        createElement("input", { type: "radio", style: { 'display': 'none' }, name: name, value: value, checked: checked, onChange: handleChange }),
        label));
};
RadioGroupItem.displayName = 'RadioGroupItem';
export default RadioGroupItem;
